import { AxiosRequestConfig, RawAxiosRequestHeaders } from "axios";
import { WorkOrderData } from "DTO/userWorkOrderListDto";
import * as piexif from "piexif-ts";

export const checkIsEmail = (email: string): boolean => {
  const emailRegexp =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegexp.test(email);
};

export const checkIsPassword = (password: string): boolean => {
  const passwordRegexp =
    /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,15}/;
  return passwordRegexp.test(password);
};

export const parseJwt = (token: string) => {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
};

export const addHeaders = (
  extraHeader?: RawAxiosRequestHeaders
): AxiosRequestConfig => {
  return {
    withCredentials: true,
    headers: {
      "X-CSRF-Token": document.cookie
        .split(";")
        .find((c) => c.trim().startsWith("csrf_access_token"))
        ?.split("=")[1],
      ...extraHeader,
    },
  };
};

type Entry = { [key: string]: any };
/**
 * Sort ascending / descending
 * Can be used in table to sort content
 */
export function toSorted(
  a: Entry,
  b: Entry,
  sortColumn: keyof Entry,
  sortAscending: boolean
) {
  if (a[sortColumn] === undefined && b[sortColumn] === undefined) return 0;
  if (a[sortColumn] === undefined) return sortAscending ? -1 : 1;
  if (b[sortColumn] === undefined) return sortAscending ? 1 : -1;
  const valA = a[sortColumn]?.toString() || "";
  const valB = b[sortColumn]?.toString() || "";

  const comparison = valA.localeCompare(valB, "sv", { sensitivity: "base" });
  if (comparison) return sortAscending ? comparison : -comparison;
  return 0;
}

/**
 *
 * Adds  GPS EXIF data to image url before downloading.
 */

function degToDmsRational(deg: number): [number, number][] {
  const d = Math.floor(deg);
  const minFloat = (deg - d) * 60;
  const m = Math.floor(minFloat);
  const secFloat = (minFloat - m) * 60;
  const s = Math.round(secFloat * 100);

  return [
    [d, 1],
    [m, 1],
    [s, 100],
  ];
}

export function addGpsExifToDataUrl(
  dataURL: string,
  latitude: number,
  longitude: number
): string {
  const gps: Record<number, any> = {
    1: latitude >= 0 ? "N" : "S",
    2: degToDmsRational(Math.abs(latitude)),
    3: longitude >= 0 ? "E" : "W",
    4: degToDmsRational(Math.abs(longitude)),
  };

  const exifObj = { GPS: gps };
  const exifStr = piexif.dump(exifObj);
  const stripped = piexif.remove(dataURL);
  return piexif.insert(exifStr, stripped);
}

export function triggerDownload(
  blob: Blob,
  index: number,
  currentWorkOrder: WorkOrderData | undefined
) {
  if (!currentWorkOrder) return;
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.target = "_blank";
  link.download = currentWorkOrder?.ImageData[index]?.name ?? "file";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export async function downloadFileClick(
  fileURL: string,
  showError?: () => void,
  isStaticFile: boolean = false
) {
  try {
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.href = fileURL;
    if (!isStaticFile) {
      a.target = "_blank";
    }
    a.download = "file";
    a.click();
    document.body.removeChild(a);
  } catch (error) {
    console.error(error);
    showError && showError();
  }
}
